export const PUZZLE_OPEN_SCOREBOARD_KEY = "puzzle-open-scoreboard";

/** Comment id to scroll into view after opening scoreboard from a comment-like notification. */
export const PUZZLE_FOCUS_COMMENT_ID_KEY = "puzzle-focus-comment-id";

/** Puzzle pathname paired with {@link PUZZLE_FOCUS_COMMENT_ID_KEY} to avoid cross-puzzle stale focus. */
export const PUZZLE_FOCUS_COMMENT_PATH_KEY = "puzzle-focus-comment-path";

/** Set before Auth0 redirect when guest taps Save; cleared after scoreboard row loads post-registration. */
export const PUZZLE_GUEST_SCORES_MIGRATING_KEY = "puzzle-guest-scores-migrating";

/** Guest streak interstitial shown at most once per browser session. */
export const PUZZLE_GUEST_STREAK_MODAL_SHOWN_KEY = "puzzle-guest-streak-modal-shown";

/** Guest puzzle completions queued for POST /users/find-or-create on registration (object keyed by playable property id). LSS localStorage key: `priceme_pending_guesses`. */
export const PUZZLE_PENDING_GUESSES_KEY = "priceme_pending_guesses";

/** Guest like intents replayed via like APIs after sign-in (sessionStorage key: `priceme_pending_likes`). */
export const PUZZLE_PENDING_LIKES_KEY = "priceme_pending_likes";

/** Overrides Register Mixpanel `location` for the next find-or-create (set before Auth0 redirect). */
export const PUZZLE_REGISTER_LOCATION_KEY = "puzzle-register-location";

